import FeaturedImages from "./FeaturedImages";

export default FeaturedImages;
